// TimeContext.js
import React, { createContext, useState } from 'react';

const TimeContext = createContext();

export const TimeProvider = ({ children }) => {
    // 画面初期表示時 or 表示時刻変更時のunixtime
    const [initialTime, setInitialTime] = useState(Date.now());
    // 初期時刻の参照（選択分を変更したときの基準時刻）
    const [baseTime, setBaseTime] = useState(new Date(2025, 2, 14, 17, 0, 0));
    // 倍速設定（1, 2, 5, 10倍など）
    const [speedMultiplier, setSpeedMultiplier] = useState(1);
    // 表示時刻
    const [displayTime, setDisplayTime] = useState(new Date(2025, 2, 14, 17, 0, 0));

    const value = {
        // 状態
        initialTime,
        baseTime,
        speedMultiplier,
        displayTime,

        // 更新関数
        setInitialTime,
        setBaseTime,
        setSpeedMultiplier,
        setDisplayTime,
    };

    return (
        <TimeContext.Provider value={value}>
            {children}
        </TimeContext.Provider>
    );
};

export const useTime = () => {
    const context = React.useContext(TimeContext);
    if (context === undefined) {
        throw new Error('useTime must be used within a TimeProvider');
    }
    return context;
};

export default TimeContext;
